<div class="exec-picker">

  <!-- ── Recommendations view ── -->
  @let recs = availableRecommendations;
  @if (!showAll() && recs.length > 0) {
    <div class="exec-picker__rec-box">
      <p class="exec-picker__label">Recommended:</p>
        <div class="exec-picker__grid">
          @for (exec of recs; track exec.email) {
            <button type="button" class="exec-tile"
              [disabled]="disabled"
              (click)="onSelect(exec)"
              [attr.aria-label]="'Select ' + exec.name">
              <div class="exec-tile__header">
                <span class="exec-tile__name">{{ exec.name }}</span>
                @if (exec.department) { <span class="exec-tile__dept">{{ exec.department }}</span> }
              </div>
              @if (exec.title) { <span class="exec-tile__title">{{ exec.title }}</span> }
              @let sd = slotDisplayData(exec);
              @if (sd.total > 0) {
                <span class="exec-tile__tz"><i class="pi pi-clock" aria-hidden="true"></i>Times shown in {{ execTimezoneLabel(exec) }}</span>
                <div class="exec-tile__slots-list">
                  @for (slot of sd.visible; track slot) {
                    <span class="exec-tile__slot"><i class="pi pi-calendar" aria-hidden="true"></i>{{ formatSlot(slot, exec) }}<span class="exec-tile__slot-tz">{{ execTimezoneLabel(exec) }}</span></span>
                  }
                  @if (sd.total > 3) {
                    <button type="button" class="exec-tile__slots-more"
                      (click)="toggleSlotExpand(exec.cp_user_slug, $event)">
                      {{ isExpanded(exec.cp_user_slug) ? 'Show less' : '+' + (sd.total - 3) + ' more' }}
                    </button>
                  }
                </div>
              } @else {
                <span class="exec-tile__slots exec-tile__slots--none"><i class="pi pi-calendar" aria-hidden="true"></i>No slots available</span>
              }
            </button>
          }
        </div>
    </div>
  }

  <!-- ── All executives view ── -->
  @if (showAll() || recs.length === 0) {
    <p class="exec-picker__label exec-picker__label--all">
      @if (filterLabel) { Available — {{ filterLabel }}: }
      @else { All executives: }
    </p>
    <div class="exec-picker__grid">
      @for (exec of execsForAllView; track exec.email) {
        <button type="button" class="exec-tile"
          [disabled]="disabled"
          (click)="onSelect(exec)"
          [attr.aria-label]="'Select ' + exec.name">
          <div class="exec-tile__header">
            <span class="exec-tile__name">{{ exec.name }}</span>
            @if (exec.department) { <span class="exec-tile__dept">{{ exec.department }}</span> }
          </div>
          @if (exec.title) { <span class="exec-tile__title">{{ exec.title }}</span> }
          @if (exec.next_slots != null) {
            @let sd = slotDisplayData(exec);
            @if (sd.total > 0) {
              <span class="exec-tile__tz"><i class="pi pi-clock" aria-hidden="true"></i>Times shown in {{ execTimezoneLabel(exec) }}</span>
              <div class="exec-tile__slots-list">
                @for (slot of sd.visible; track slot) {
                  <span class="exec-tile__slot"><i class="pi pi-calendar" aria-hidden="true"></i>{{ formatSlot(slot, exec) }}<span class="exec-tile__slot-tz">{{ execTimezoneLabel(exec) }}</span></span>
                }
                @if (sd.total > 3) {
                  <button type="button" class="exec-tile__slots-more"
                    (click)="toggleSlotExpand(exec.cp_user_slug, $event)">
                    {{ isExpanded(exec.cp_user_slug) ? 'Show less' : '+' + (sd.total - 3) + ' more' }}
                  </button>
                }
              </div>
            } @else {
              <span class="exec-tile__slots exec-tile__slots--none"><i class="pi pi-calendar" aria-hidden="true"></i>No upcoming availability</span>
            }
          } @else {
            <span class="exec-tile__slots exec-tile__slots--none"><i class="pi pi-calendar" aria-hidden="true"></i>No slots available</span>
          }
        </button>
      }
      @if (execsForAllView.length === 0) {
        <p class="exec-picker__no-slots" style="grid-column:1/-1">No executives available in this range.</p>
      }
    </div>
  }

  <!-- ── Search / filter bar ── -->
  <div class="exec-picker__search-bar">
    @if (showCustomInput()) {
      <div class="exec-picker__custom-range">
        <label class="exec-picker__custom-label">From</label>
        <input type="date" class="exec-picker__date-input" [value]="customFrom()" (change)="onCustomFromChange($event)" />
        <label class="exec-picker__custom-label">To</label>
        <input type="date" class="exec-picker__date-input" [value]="customTo()" (change)="onCustomToChange($event)" />
        <button type="button" class="filter-btn filter-btn--active" (click)="onApplyCustom()">Apply</button>
        <button type="button" class="filter-btn" (click)="onCancelCustom()">Cancel</button>
      </div>
    } @else {
      <div class="exec-picker__filter-actions">
        <button type="button" class="filter-btn" [class.filter-btn--active]="!showAll() && recs.length > 0" (click)="onShowRecs()">Recommended</button>
        <button type="button" class="filter-btn" [class.filter-btn--active]="showAll() && !windowFilter() && !customFrom()" (click)="onShowAll()">See all</button>
        <button type="button" class="filter-btn" [class.filter-btn--active]="!!customFrom()" (click)="onShowCustom()">Custom range</button>
      </div>
    }
  </div>

</div>
